import { Injectable } from "@angular/core";
import { DbTableDefinition } from "src/app/_services/persistence/db-persistence/db-table-definition";

@Injectable({
  providedIn: 'root'
})
export class TourDbTableDefinition extends DbTableDefinition {
    tableName = 'tours';
    tableStructure = `(id BIGINT(20) PRIMARY KEY null,
       label TEXT NOT NULL,
       databag LONGTEXT,
       description TEXT,
       status INT(11),
       extid VARCHAR(60),
       tournumber VARCHAR(100),
       templatetournumber VARCHAR(100),
       shortname LONGTEXT,
       type INT(11),
       startTstamp BIGINT(20),
       endTstamp BIGINT(20),
       plannedstarttstamp BIGINT(20),
       plannedendtstamp BIGINT(20),
       tourdate BIGINT(20),
       stops INT(11),
       employeeid BIGINT(20),
       employeelabel TEXT,
       carid BIGINT(20),
       carlabel TEXT
      );`;

      constructor() {
        super();
        // Add UpdateStatements to Map
      }
}